module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/sightseeing_1-440e9248afa112321d4a0dc11609d2d7.jpg";